var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9.46501V11.01C16.5 11.43 16.155 11.775 15.7275 11.775H14.28C13.47 11.775 12.7275 11.1825 12.66 10.3725C12.615 9.90001 12.795 9.45751 13.11 9.15001C13.3875 8.86501 13.77 8.70001 14.19 8.70001H15.7275C16.155 8.70001 16.5 9.04501 16.5 9.46501Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.535 10.47C11.4675 9.68249 11.7525 8.90999 12.3225 8.34749C12.8025 7.85999 13.47 7.57499 14.19 7.57499H14.6175C14.8275 7.57499 15 7.40249 14.97 7.19249C14.7675 5.73749 13.5075 4.61249 12 4.61249H4.5C2.8425 4.61249 1.5 5.95499 1.5 7.61249V12.8625C1.5 14.52 2.8425 15.8625 4.5 15.8625H12C13.515 15.8625 14.7675 14.7375 14.97 13.2825C15 13.0725 14.8275 12.9 14.6175 12.9H14.28C12.855 12.9 11.655 11.835 11.535 10.47ZM9.75 8.92499H5.25C4.9425 8.92499 4.6875 8.67749 4.6875 8.36249C4.6875 8.04749 4.9425 7.79999 5.25 7.79999H9.75C10.0575 7.79999 10.3125 8.05499 10.3125 8.36249C10.3125 8.66999 10.0575 8.92499 9.75 8.92499Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6575 2.98501C10.8525 3.18751 10.68 3.48751 10.395 3.48751H4.52249C3.70499 3.48751 2.93999 3.72751 2.30249 4.14001C2.00999 4.32751 1.61249 4.12501 1.75499 3.80251C2.17499 2.82001 3.15749 2.13751 4.28999 2.13751H8.50499C9.37499 2.13751 10.1475 2.44501 10.6575 2.98501Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.c89dc97d0a529b2377c5cbe2fd3fff6d.svg";
export { ForwardRef as ReactComponent };